/* LVC 27/10/2026 - Header and mobile footer cart icons always target the native theme cart drawer.
   No simulated click, cart mutation, duplicate event, or checkout interception. */
(function () {
  'use strict';
  var iconSelector = 'a[id^="cart-icon-bubble"], a#cart-icon-bubble--footer';
  function openCart(e) {
    var trigger = e.target && e.target.closest && e.target.closest(iconSelector);
    if (!trigger) return;
    if (e.button !== undefined && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // Keep the normal link if drawer is unavailable.
    e.preventDefault();
    e.stopImmediatePropagation(); // Prevent competing cart handlers from opening /cart or opening the drawer twice.
    if (!drawer.classList.contains('active')) drawer.open(trigger);
  }
  document.addEventListener('click', openCart, true);
})();

(function () {
  'use strict';
  async function refreshDrawer(data, trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('Carrito lateral no disponible');
    const sections = drawer.getSectionsToRender().filter(section => section.selector ? document.querySelector(section.selector) : document.getElementById(section.id)).map(section => section.id);
    if (!sections.every(id => typeof data.sections?.[id] === 'string')) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + '?sections=' + encodeURIComponent(sections.join(',')), {headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('El producto se ha añadido, pero no se pudo actualizar el carrito');
      data.sections = await response.json();
      if (!sections.every(id => typeof data.sections?.[id] === 'string')) throw new Error('No se pudo cargar el carrito lateral. Actualiza la página para revisar tu compra.');
    }
    drawer.setActiveElement(trigger || document.activeElement);
    drawer.classList.remove('is-empty');
    drawer.renderContents(data);
    return data;
  }
  window.lvcRefreshDrawer = refreshDrawer;
  async function addToDrawer(payload, trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('Carrito lateral no disponible');
    const sections = drawer.getSectionsToRender().map(section => section.id);
    const body = payload instanceof FormData ? payload : new FormData();
    if (!(payload instanceof FormData)) Object.entries(payload).forEach(([key, value]) => body.set(key, value));
    body.set('sections', sections.join(','));
    body.set('sections_url', window.location.pathname);
    drawer.setActiveElement(trigger || document.activeElement);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'No se pudo añadir el producto');
    return refreshDrawer(data, trigger);
  }
  window.lvcAddToDrawer = addToDrawer;
  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.closest('product-form')) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    if (!document.querySelector('cart-drawer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.lvcDrawerBusy === 'true') return;
    const trigger = event.submitter || form.querySelector('[type="submit"]');
    if (trigger?.disabled) return;
    const body = new FormData(form);
    form.dataset.lvcDrawerBusy = 'true';
    if (trigger) trigger.disabled = true;
    try {
      await addToDrawer(body, trigger);
    } catch (error) {
      let message = form.querySelector('[data-lvc-drawer-error]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.lvcDrawerError = '';
        message.setAttribute('role', 'alert');
        form.appendChild(message);
      }
      message.textContent = error.message;
    } finally {
      delete form.dataset.lvcDrawerBusy;
      if (trigger) trigger.disabled = false;
    }
  }, true);
})();

